/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ComuneCittadinoListFilter } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelComuneCittadinoSummaryDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface ListComuniCittadinoRequestParams {
    filter: ComuneCittadinoListFilter;
    pageable: Pageable;
}


export interface CittadinoCatalogoComuniServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Lista paginata dei comuni con almeno un bando visibile al cittadino. Filtri opzionali: q (substring nome+slug), has_bandi_aperti (Boolean). Default sort: nome ASC.
     * 
     * @endpoint get /api/v1/cittadino/comuni
* @param requestParameters
     */
    listComuniCittadino(requestParameters: ListComuniCittadinoRequestParams, extraHttpRequestParams?: any): Observable<PagedModelComuneCittadinoSummaryDTO>;

}
